import { Component, OnInit, ViewChild, ElementRef, Renderer2, HostListener, OnDestroy } from '@angular/core';
import { DashboardService } from './my-dashboard.service';
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);
// import SwiperCore, { Navigation, Swiper, SwiperOptions, Virtual } from 'swiper';
// import { SwiperComponent, SwiperModule } from "swiper/angular";
import { SharedService } from '../../../../shared/shared.service';
import { NavigationExtras, Router } from '@angular/router';
import * as moment from 'moment';

import { SlickCarouselComponent } from 'ngx-slick-carousel';
import { MiniclipsModalComponent } from 'src/app/modules/learning-center/modals/miniclips-modal/miniclips-modal.component';

// import SwiperCore, { Swiper } from 'swiper/core';
// import  { SwiperModule } from 'swiper/core';
// import { SwiperModule } from 'swiper/types';
// import 'swiper/swiper-bundle.css';

// SwiperCore.use([Swiper]);

import {
	ChartComponent,
	ApexAxisChartSeries,
	ApexChart,
	ApexXAxis,
	ApexDataLabels,
	ApexTooltip,
	ApexStroke,
	ApexYAxis,
	ApexPlotOptions,
	ApexLegend,
	ApexStates,
	ApexGrid,
	ApexTitleSubtitle,
} from "ng-apexcharts";
import { NgxSpinnerService } from 'ngx-spinner';
import { ProgramPageService } from '../program-page/program-page.service';
import { DateRangeType, IgxCalendarComponent } from 'igniteui-angular';
import { UsersService } from '../../../management/components/tabs/components/users/users.service';
// SwiperCore.use([Virtual]);
import { trigger, transition, style, animate, state } from '@angular/animations';
import { IntroVideoModalComponent } from 'src/app/shared/modals/intro-video-modal/intro-video-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { HelpSupportModalComponent } from 'src/app/modules/help-and-support/modals/help-support-modal/help-support-modal.component';
import { LikesService } from 'src/app/shared/likes.service';
import WaveSurfer from 'wavesurfer.js';
import { MatBottomSheet, MatBottomSheetConfig } from '@angular/material/bottom-sheet';
import { MobilePodcastComponent } from './mobile-podcast/mobile-podcast.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subscription } from 'rxjs';
import { PostHogService } from 'src/app/shared/services/posthog.service';
import {
	POSTHOG_EVENT_DAILY_DOSE_DOC,
	POSTHOG_EVENT_DAILY_DOSE_LETS_GO,
	POSTHOG_EVENT_FAVOURITE_DAILY_DOSE,
	POSTHOG_EVENT_LATEST_DAILY_DOSE_PODCAST_PLAY,
	POSTHOG_EVENT_SAVE_COMMENT_DAILY_DOSE
} from 'src/app/shared/constants/posthog-events.constants';


export type ChartOptions3 = {
	series: ApexAxisChartSeries;
	chart: ApexChart;
	dataLabels: ApexDataLabels;
	plotOptions: ApexPlotOptions;
	yaxis: ApexYAxis;
	xaxis: ApexXAxis;
	grid: ApexGrid;
	subtitle: ApexTitleSubtitle;
	colors: string[];
	states: ApexStates;
	title: ApexTitleSubtitle;
	legend: ApexLegend;
	tooltip: any; //ApexTooltip;
};

export type ChartOptions = {
	series: ApexAxisChartSeries;
	chart: ApexChart;
	xaxis: ApexXAxis;
	yaxis: ApexYAxis;
	stroke: ApexStroke;
	tooltip: ApexTooltip;
	dataLabels: ApexDataLabels;
};

@Component({
	selector: 'app-my-dashboard',
	templateUrl: './my-dashboard.component.html',
	styleUrls: ['./my-dashboard.component.scss'],
	animations: [
		trigger('emojiAnimation', [
			state('inactive', style({
				transform: 'scale(1)',
				opacity: 1,
				top: '0',
			})),
			state('active', style({
				transform: 'scale(2)',
				opacity: 1,
				top: '100px',
				marginBottom: '100px'
			})),
			transition('inactive <=> active', [
				animate('0.5s ease-in-out')
			]),
		]),
		trigger('widthGrow', [
			state('closed', style({
				width: 0,
			})),
			state('open', style({
				width: 760,
				maxWidth: '50%'

			})),
			transition('* => *', animate(150))
		]),
		trigger('widthGrowOpacity', [
			state('closed', style({
				width: 0,
			})),
			state('open', style({
				width: 10000,
			})),
			// transition('* => *', animate(10))
		]),

	]
})
export class MyDashboardComponent implements OnInit, OnDestroy {
	touchStartX!: number;
	touchEndX!: number;
	touchThreshold: number = 50;
	weeklyImagePath: string = ''
	// @ViewChild('cardElement') cardElement!: ElementRef;
	cardElement: ElementRef<HTMLImageElement> | undefined;
	desktopCardImage: ElementRef<HTMLImageElement> | undefined;

	@HostListener('window:message', ['$event'])
	@ViewChild('Insta-box') instaBox!: ElementRef;
	currentIndex = 0;
	translateValue = '0';
	items = [
		{ id: 1, title: 'Item 1' },
		{ id: 2, title: 'Item 2' },
		{ id: 3, title: 'Item 3' },
		// Add more items as needed
	];
	carouselConfig = {
		slidesToShow: 4,
		slidesToScroll: 1,
		dots: true,
		infinite: false,
		responsive: [
			{
				breakpoint: 800,
				settings: {
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
				}
			}
		]
	};
	@ViewChild('slickModal', { static: true }) slickModal!: SlickCarouselComponent;
	state = "closed";
	slides = [
		{ img: "http://placehold.it/350x150/000000" },
		{ img: "http://placehold.it/350x150/111111" },
		{ img: "http://placehold.it/350x150/333333" }
	];
	slideConfig = {
		"slidesToShow": 3,
		"slidesToScroll": 1,
		"dots": true,
		"infinite": false,
		"responsive": [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: true,
					dots: true
				}
			},
			{
				breakpoint: 800,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	};
	currentSlideIndex = 0;
	// @ViewChild('swiper', { static: false }) swiper?: SwiperComponent;
	// @ViewChild('swiperTwo', { static: false }) swiperTwo?: SwiperComponent;
	public chartOptions3!: Partial<ChartOptions> | any;
	@ViewChild("chart") chart2!: ChartComponent;
	public chartOptions!: Partial<ChartOptions> | any;
	headerTitle: any = ' '
	barHeight1: any = 50;
	barHeight2: any = 80;
	barHeight3: any = 100;
	barHeight4: any = 70;
	barHeight5: any = 90;
	username: any;
	chart: any;
	data: any;
	hasProgress: boolean = false;
	// config: SwiperOptions = {
	// 	slidesPerView: 1,
	// 	slidesPerGroup: 1,
	// 	spaceBetween: 50
	// };
	programStartDate: any;
	currentDate: moment.Moment;
	todaysDfs: number = 0;
	randomQuote: any = {};
	months = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	daysInRow: number = 0;
	learningThisMonth: number = 0;
	daysLoggedThisMonth: number = 0;
	// targetDateLabels: any = [];
	blockLoader: string = "blockLoader";
	activePrograms: any = [];
	formatOptions: any;
	formatViews: any;
	@ViewChild('targetCalendar', { read: IgxCalendarComponent }) public targetCalendar: any;
	numProgramsCompleted: any = 0;
	dosesCompleted: number = 0;
	dosesCompletedThisMonth: number = 0;
	quizzesCompleted: number = 0;
	sectionsCompleted: number = 0;
	activeProgramsMessage: string = "";
	userId = "";
	currentMonth: string = "";
	loginTime: number = 0;
	newVisitorIntroduction: any = false;
	hideIntroVideo = false;
	miniClipCoverImage: any;
	showEmojiTab: any = false;
	showEmojiTab2: any = false;
	showEmojiTab3: any = false;
	emojisList: any = []
	showHeart: any = true;
	showHeart2: any = true;
	showHeart3: any = true;
	selectedEmoji: string | null = null;
	isAnimating: boolean = false;
	highlightedEmoji: any;
	allLikesData: any;
	selectedPodcastEmojiType: any = '';
	selectedQuoteEmojiType: any = ''
	highlightedPodcastEmojiType: any = '';
	highlightedQuoteEmojiType: any = '';
	selectedMiniClipEmojiType: any = ''
	highlightedMiniClipEmojiType: any = '';
	allLikes: any;
	doseAlgoRes: string = '';
	userData: any;
	activeProgramsLoaded = false;
	firstName: string = '';

	@ViewChild('waveform') private waveformElement?: ElementRef<HTMLDivElement>;
	wavesurfer?: WaveSurfer;
	audioUrls: string[] = [
		// '../../../../../assets/sample-3s.mp3'
		// "../../../../../assets/orchestrawav-26158.mp3"
	];
	urlIndex: number = 0;
	isPlaying: boolean = false;
	currentTime: any = 0;
	durationTime: any = 0;
	skipForward: any = 0;
	skipBackward: any = 0;
	prgNameHeight: number = 0;
	currentPipValue: any;
	// @ViewChild('myElement') myElement: ElementRef | undefined;
	podcasts: any = [];
	selectedPodcast: any;
	selectedPodcastSeason: any;
	selectedPodcastEpisode: any;
	likesIdData: any;
	commentsIdData: any;
	likeDocId: any;
	commentDocId: any;
	commentBoxText: string = "";
	selectPodcastIndex: any;
	isMuted: boolean = false;
	dailyQuoteSrc: string = "../../../../../assets/images/quote_images/Daily-quotes-default2.png";
	isiPhone: boolean = false;
	waveSurferElements: any = [];
	isLoadingWavesurfer: boolean = false;
	podcastLoaderImg = "../../../../../assets/images/Podcast-Loader-Img.jpg";
	customWaveSurfer: any[] = [];
	wavesProgress: any = [];
	quoteIndex: number = 0;
	orgId: any = "";
	isCompleteAlgoBoxOpen: boolean = false;
	isMonthlyDoseBoxOpen: boolean = false;
	isQuoteLiked: boolean = false;
	quotelikeSubscription: Subscription | undefined;

	constructor(
		private router: Router,
		private snackbar: MatSnackBar,
		private sharedService: SharedService,
		private dashboardService: DashboardService,
		private elRef: ElementRef,
		private renderer: Renderer2,
		private dialogRef: MatDialog,
		private likesService: LikesService,
		private _bottomSheet: MatBottomSheet,
		private spinner: NgxSpinnerService,
		private deviceDetectorService: DeviceDetectorService,
		private posthog: PostHogService
	) {
		this.getRadius();
		this.getOuterStrokeWidth();
		this.getInnerStrokeWidth();
		this.getSpace();
		this.getTitleFontSize();
		this.programStartDate = moment("20230301");
		this.currentDate = moment().startOf("day");
		const daysSinceProgramStarted = this.currentDate.diff(this.programStartDate, "days");
		this.todaysDfs = daysSinceProgramStarted + 1;
		this.state = "closed";

		this.chartOptions = {
			// olors: ['#F44336', '#E91E63', '#9C27B0'],
			markers: {
				colors: ['#7468ED', '#E91E63', '#9C27B0']
			},
			fill: {
				colors: ['#F44336', '#E91E63', '#9C27B0'],
				type: 'gradient',
				gradient: {
					shadeIntensity: 1,
					opacityFrom: 0.7,
					opacityTo: 0.9,
					stops: [7, 104, 237]
				}
			},
			grid: {
				show: false,
			},
			series: [
				{
					name: "Progress",
					data: [0]
				},
			],
			chart: {
				height: 207,
				type: "area",
				toolbar: {
					show: false,
				},
			},
			dataLabels: {
				enabled: false
			},
			stroke: {
				curve: "smooth"
			},
			yaxis: {
				min: 0, max: 100, tickInterval: 25,
				title: {
					text: "title"
				},
				labels: {
					format: '{value}%',
				}
			},
			xaxis: {
				lines: {
					show: false
				},
				labels: {
					show: false
				},
				type: "area",
			},
			tooltip: {
				x: {
				}
			}
		};

		this.chartOptions3 = {
			series: [
				{
					data: [400, 300, 600, 1380]
				}
			],
			chart: {
				type: "bar",
				height: 140,
				width: 200,
				toolbar: {
					show: false,
				},
			},
			plotOptions: {
				bar: {
					barHeight: "100%",
					distributed: true,
					horizontal: true,
					// distributed: true,
					columnWidth: "10%",
					dataLabels: {
						position: "bottom"
					}
				}
			},
			colors: ['#FED42D', '#FF8C95', '#74CDFF', '#8E30FF', '#7468ED', '#8CF6CE'],
			dataLabels: {
				enabled: false
			},
			stroke: {
				width: 1,
				colors: ["#fff"]
			},
			grid: {
				show: false,
			},
			yaxis: {
				lines: {
					show: false
				},
				labels: {
					show: false
				},
				type: "area",
			},
			xaxis: {
				lines: {
					show: false
				},
				labels: {
					show: false
				},
				type: "area",
			},
			tooltip: {
				x: {
					show: false
				},

			}
		};

		if (this.sharedService.isLeapYear()) {
			this.months[1] = 29;
		}

		this.formatOptions = { day: '2-digit', month: 'long', weekday: 'short' };
		this.formatViews = { day: true, month: true, year: true };
		this.username = localStorage.getItem('firstName');

		const fullName = this.username.split(" ");
		this.firstName = fullName[0];

		const newDate = new Date();
		if ((newDate.getMonth() + 1) <= 9) {
			this.currentMonth += `0${(newDate.getMonth() + 1)}`;
		} else {
			this.currentMonth += `${(newDate.getMonth() + 1)}`;
		}

		this.currentMonth += `-${newDate.getFullYear()}`;
		this.orgId = localStorage.getItem('orgId');
	}

	goToSlide(index: number) {
		this.currentIndex = index;
		this.translateValue = `-${index * 50}%`;
	}

	async ngOnInit() {
		this.weeklyImagePath = this.getWeeklyImagePath();
		this.isiPhone = this.deviceDetectorService.isMobile() && this.deviceDetectorService.device === 'iPhone';
		// console.log('isiPhone', this.isiPhone)

		this.userId = localStorage.getItem("userId") ?? "";
		const activePrgs = await this.sharedService.getActivePrograms(this.userId);

		this.activePrograms = activePrgs;

		this.activeProgramsLoaded = true;
		await this.getMiniClipCoverImage();
		await this.setInspirationalQuote();
		this.sortActiveProgramsByAccessOrder();
		this.numProgramsCompleted = this.getProgramsCompleted();
		if (this.activePrograms.length >= 1) {
			this.hasProgress = true;
		} else {
			this.hasProgress = false;
		}
		for (let program of this.activePrograms) {
			this.daysInRow += Number(this.getDaysInRow(program.daysInRow));
			this.learningThisMonth += this.getLearningMinutesOverall(program.sections);
		}
		this.learningThisMonth = Math.ceil(this.learningThisMonth);

		// await this.spinner.show("blockLoader");
		this.userData = await this.dashboardService.getUserData();
		if (this.userData.quoteIndex) {
			this.quoteIndex = this.userData.quoteIndex;
		}
		this.showCurrentMonthDates();

		// const randInt = Math.floor(Math.random() * 332) + 1;
		const dailyQuoteSrcData: any = await this.dashboardService.getDailyQuotesData();
		// console.log(dailyQuoteSrcData);
		this.dailyQuoteSrc = dailyQuoteSrcData[this.quoteIndex];

		this.quotelikeSubscription = this.likesService.checkIsQuoteLiked(this.quoteIndex, this.userId)?.subscribe(data => {
			if (data && data.length > 0) {
				this.isQuoteLiked = true;
			} else {
				this.isQuoteLiked = false;
			}
		})

		if (this.userData?.loginHistory && Object.keys(this.userData?.loginHistory).length >= 1) {
			if (this.userData.loginHistory[this.currentMonth]) {
				this.loginTime = this.userData.loginHistory.currentMonth;
				setTimeout(async () => {
					this.loginTime += 5;
					await this.updateLoginTime(this.userData);
				}, 5000);
			} else {
				this.loginTime = 5;
				setTimeout(async () => {
					await this.updateLoginTime(this.userData);
				}, 5000);
			}
		}
		// await this.spinner.hide("blockLoader");
		// this.getFontSize()
		this.instagramContainerHeight();
		this.setCircleProgressDimensions();
		this.setInstaMObileHeight();
		this.dosesCompleted = this.getDosesCompleted();
		this.dosesCompletedThisMonth = this.getDosesCompletedThisMonth();
		this.quizzesCompleted = this.getQuizzesCompleted();
		this.sectionsCompleted = this.getSectionsCompleted();
		this.activeProgramsMessage = this.getActiveProgramsMessage();
		this.doseAlgoRes = this.getDoseAlgoRes();
		this.setNewVisitorIntroduction()
		this.newVisitorIntroduction = localStorage.getItem('newVisitorIntroduction');
		// console.log('newVisitorIntroduction', this.newVisitorIntroduction)
		if (this.newVisitorIntroduction === 'true') {
			// this.openIntroVideoModal()
		}
		this.emojisList = [
			// '👍', '😝', '❤️', '🔥', '😍'
			{ emoji: '👍', emotionType: 'luck' },
			{ emoji: '😝', emotionType: 'laugh' },
			{ emoji: '❤️', emotionType: 'heart' },
			{ emoji: '🔥', emotionType: 'fire' },
			{ emoji: '😍', emotionType: 'beautiful' },
		]

		this.likesService.getPIPValue().subscribe(async value => {
			this.currentPipValue = value;
			// await this.onDeviceWidthChange();
			this.adjustWaveSurferOptions();
			if ((this.currentPipValue === 'maximize') && window.innerWidth < 500) {
				const bottomSheetConfig: MatBottomSheetConfig = {
					panelClass: 'mobile-podcast',
					data: {
						isOpen: true,
						podcasts: this.podcasts,
						likesData: this.likesIdData,
						commentsData: this.commentsIdData,
						audioUrls: this.audioUrls,
						userId: this.userId,
						userData: this.userData,
					}
				};
				this._bottomSheet.open(MobilePodcastComponent, bottomSheetConfig);
			}

			if (this.currentPipValue === 'maximize' && window.innerWidth > 500) {
				const currTime = this.likesService.currentTimeValue.getValue();
				this.wavesurfer?.setTime(currTime);

				setTimeout(() => {
					let playingState: any = localStorage.getItem('playingStateMax');
					// console.log(playingState);
					if (playingState === "true") {
						playingState = true;
					} else {
						playingState = false;
					}
					if (this.wavesurfer && playingState) {
						this.wavesurfer.play();
					}
				}, 100);
			}
		});

		if (dailyQuoteSrcData.length === this.quoteIndex + 1) {
			await this.dashboardService.updateQuoteIndex(this.userId, 0)
		} else {
			await this.dashboardService.updateQuoteIndex(this.userId, this.quoteIndex + 1)
		}

		await this.sharedService.saveLastAccessTime(this.userId ?? "");
	}

	async ngAfterViewInit() {
		this.adjustInstaBoxHeight();

		this.likesIdData = await this.likesService.getUserLikes(this.userId);
		this.commentsIdData = await this.likesService.getUserComments(this.userId);
		// console.log('commentsIdData', this.commentsIdData);

		let podcastArr: any = await this.dashboardService.getPodcasts();
		podcastArr = podcastArr.filter((podcast: any) => !podcast.private);
		// console.log(podcastArr);
		this.podcasts = ["", ...podcastArr];

		this.initWavesProgress();
		// this.sortByEpisodeNumber();
		for (let podcast of this.podcasts) {
			if (podcast) {
				podcast.formattedPublishingDate = moment(podcast.published_at).utcOffset("-0500").format("Do MMM YYYY");
				this.audioUrls.push(podcast.audio_url);
				// podcast.description = podcast.description.replace(/<[^>]*>?/gm, '');
				// podcast.description = podcast.description.replace("&nbsp;", " ");
			}
		}
		// console.log(this.audioUrls);
		if (this.podcasts && this.podcasts.length >= 2) {
			this.selectedPodcast = this.podcasts[1];
			this.podcastLoaderImg = this.podcasts[1].artwork_url;
			// this.likesService.selectedPodcastValue.next(this.selectedPodcast);
			this.selectedPodcastSeason = this.selectedPodcast.season_number;
			this.selectedPodcastEpisode = this.selectedPodcast.episode_number;
			let likeDocId;
			const getEpisodeLike = this.likesIdData.findIndex((likeData: any) => {
				let entityId = `${this.selectedPodcastSeason}_${this.selectedPodcastEpisode}`;
				likeDocId = likeData.id;
				return likeData.entityId === entityId;
			});

			if (getEpisodeLike === -1) {
				this.isLiked = false;
				this.likeDocId = "";
			} else {
				this.isLiked = true;
				this.likeDocId = likeDocId;
			}

			let commentDocId;
			let commentText: any;
			const getEpisodeComment = this.commentsIdData.findIndex((commentData: any) => {
				let entityId = `${this.selectedPodcastSeason}_${this.selectedPodcastEpisode}`;
				commentDocId = commentData.id;
				commentText = commentData.text;
				return commentData.entityId === entityId;
			});

			if (getEpisodeComment === -1) {
				this.isComment = false;
				this.commentDocId = "";
				this.commentBoxText = "";
			} else {
				this.isComment = true;
				this.commentDocId = commentDocId;
				this.commentBoxText = commentText;
				this.commentCharacterCount = commentText.length;
			}

		}
		// console.log(this.podcasts);

		if (this.waveformElement) {
			this.wavesurfer = WaveSurfer.create({
				container: this.waveformElement.nativeElement,
				height: 40,
				barWidth: 3,
				barGap: 3,
				waveColor: '#fff',
				progressColor: '#7881E6',
				fetchParams: {
					mode: "no-cors",
				}
			});

			try {
				this.isLoadingWavesurfer = true;
				await this.wavesurfer.load(this.audioUrls[this.urlIndex]);
			} catch (err) {
				console.log("Error in initial loading of podcast audio.");
			} finally {
				this.isLoadingWavesurfer = false;
				// console.log("set to false!");
			}
			this.durationTime = this.selectedPodcast.duration;
			this.urlIndex = 0;
			this.onUrlChange(this.urlIndex, false);

			this.wavesurfer?.on('play', () => {
				this.isPlaying = true;
				this.likesService.playValueSubject.next(this.isPlaying);
			});
			this.wavesurfer?.on('pause', () => {
				this.isPlaying = false;
				this.likesService.playValueSubject.next(this.isPlaying);
			});

			this.wavesurfer?.on('audioprocess', () => {
				const currentTime = this.wavesurfer?.getCurrentTime();
				this.currentTime = currentTime;

				if (currentTime !== undefined) {
					this.likesService.currentTimeValue.next(currentTime);
					let progress = Number(Number((currentTime * 100 / this.durationTime) / 100).toFixed(2));
					let entityId = `${this.selectedPodcast.season_number}_${this.selectedPodcast.episode_number}`;
					let index = this.podcasts.findIndex((p: any) => {
						let podcastId = `${p.season_number}_${p.episode_number}`;
						return podcastId === entityId;
					});
					this.wavesProgress[index] = progress;
				}
			});

			this.wavesurfer?.on('interaction', () => this.skipForwardFn());
			this.wavesurfer?.on('interaction', () => this.skipBackwardFn());
			this.wavesurfer?.on('seeking', () => {
				this.currentTime = this.wavesurfer!.getCurrentTime();
			});
		}

		this.adjustWaveSurferOptions();
		this.adjustCustomWaveSurferBarsLength();
		setTimeout(() => {
			this.setWavesProgress();
		}, 1000);

		// await this.createAllWaveSurfers();
		this.dashboardService.teamAnalyticsDataFetch$.subscribe(async (status) => {
			if (status === "sleeping") {
				await this.dashboardService.getTeamAnalyticsData(this.orgId);
			}
		});
	}

	initWavesProgress() {
		for (let i = 0; i < this.podcasts.length; i += 1) {
			this.wavesProgress[i] = 0;
		}
	}

	adjustCustomWaveSurferBarsLength() {
		const barWidth = 4;
		const container = this.elRef.nativeElement.querySelector('.more-dose-bars');
		const containerWidth = container.offsetWidth;
		// console.log('container1', container.offsetWidth)
		const maxNumberOfBars = Math.floor(containerWidth / barWidth);
		this.customWaveSurfer.length = maxNumberOfBars;
		for (let i = 0; i < maxNumberOfBars; i++) {
			this.customWaveSurfer[i] = "";
		}
	}

	async createAllWaveSurfers() {
		// console.log("caws");
		this.waveSurferElements = [];
		for (let i = 0; i < this.podcasts.length; i += 1) {
			let waveformElement: any = document.getElementById("waveform" + i);
			let currPodcast = this.podcasts[i + 1];
			// console.log(waveformElement);

			if (waveformElement) {
				const wavesurfer = WaveSurfer.create({
					container: waveformElement,
					height: 20,
					barWidth: 3,
					barGap: 3,
					waveColor: '#E5E5E5',
					progressColor: '#000',
					interact: false,
					cursorColor: '#fff',
					fetchParams: {
						mode: "no-cors",
					}
				});

				wavesurfer.on("load", () => {
					this.waveSurferElements[i] = wavesurfer;
				});
				wavesurfer.setVolume(0);

				if (this.userData && this.userData.podcastsProgress) {
					let progress = 0;
					let entityId = `${currPodcast.season_number}_${currPodcast.episode_number}`;
					for (let podcast of this.userData.podcastsProgress) {
						// console.log(podcast.entityId)
						// console.log(entityId);
						if (podcast.entityId === entityId) {
							progress = podcast.progress;
							break;
						}
					}
					// console.log(progress)

					if (progress === 100) {
						// console.log("progr 100");
						wavesurfer.setOptions({
							waveColor: '#000'
						});
					} else if (progress >= 1) {
						wavesurfer.seekTo(progress);
					}
				}

				try {
					await wavesurfer.load(this.audioUrls[0]);
					await wavesurfer.load(this.audioUrls[i + 1]);
					// await wavesurfer.load(this.audioUrls[i]);
				} catch (err) {
					console.log("Unload to load other audios.")
				}
			}
		}
	}

	setWavesProgress() {
		for (let i = 1; i < this.podcasts.length; i += 1) {
			let podcast = this.podcasts[i];
			let entityId = `${podcast.season_number}_${podcast.episode_number}`;
			let progress = 0;

			// console.log(this.userData);
			if (this.userData && this.userData.podcastsProgress && this.userData.podcastsProgress.length >= 1) {
				for (let userProgressPodcast of this.userData.podcastsProgress) {
					if (userProgressPodcast.entityId === entityId) {
						progress = userProgressPodcast.progress;
						// console.log('prog to ', progress);
						break;
					}
				}
			}

			this.wavesProgress[i] = Number(Number(progress / 100).toFixed(2));
		}

		// console.log(this.wavesProgress);
	}

	async onDeviceWidthChange() {
		// console.log(this.audioUrls);
		if (this.podcasts && this.podcasts.length >= 2) {

			const podcastObservable = this.likesService.selectedPodcastValue.getValue();
			if (podcastObservable && Object.keys(podcastObservable).length >= 1) {
				this.likesService.selectedPodcastValue.next(podcastObservable);
				this.selectedPodcast = podcastObservable;
			} else {
				this.selectedPodcast = this.podcasts[1];
				this.likesService.selectedPodcastValue.next(this.selectedPodcast);
			}

			this.selectPodcastIndex = this.podcasts.findIndex((podcast: any) => {
				return this.selectedPodcast.id === podcast.id;
			})
		}
		// console.log(this.podcasts);

		this.urlIndex = this.selectPodcastIndex - 1;
		this.onUrlChange(this.urlIndex, false);
	}

	adjustWaveSurferOptions() {
		if (window.innerWidth > 500 && window.innerWidth < 700) {
			this.wavesurfer?.setOptions({
				height: 30,
				barWidth: 2,
				barGap: 2,
			})
		} else if (window.innerWidth >= 700 && window.innerWidth < 800) {
			this.wavesurfer?.setOptions({
				height: 15,
				barWidth: 2,
				barGap: 2,
			})
		}
		else if (window.innerWidth >= 800 && window.innerWidth < 850) {
			this.wavesurfer?.setOptions({
				height: 10,
				barWidth: 2,
				barGap: 2,
			})
		}
		else if (window.innerWidth >= 850 && window.innerWidth < 1050) {
			this.wavesurfer?.setOptions({
				height: 20,
				barWidth: 2,
				barGap: 2,
			})
		} else if (window.innerWidth >= 1050 && window.innerWidth < 1250) {
			this.wavesurfer?.setOptions({
				height: 10,
				barWidth: 2,
				barGap: 2,
			})
		} else if (window.innerWidth >= 1250 && window.innerWidth < 1380) {
			this.wavesurfer?.setOptions({
				height: 20,
				barWidth: 2,
				barGap: 2,
			})
		} else {
			this.wavesurfer?.setOptions({
				height: 40,
				barWidth: 3,
				barGap: 3,
			})
		}
	}

	sortByEpisodeNumber() {
		this.podcasts.sort((podcastA: any, podcastB: any) => {
			if (podcastA.episode_number < podcastB.episode_number) {
				return -1;
			} else {
				return 1;
			}
		})
	}

	adjustInstaBoxHeight() {
		if (this.instaBox) {
			this.instaBox.nativeElement.addEventListener('load', () => {
				this.adjustIframeHeight.bind(this);
			});
		} else {
			setTimeout(() => {
				this.adjustInstaBoxHeight();
			}, 500);
		}

	}

	adjustIframeHeight(event: MessageEvent) {
		if (event.data?.height && event?.source === this.instaBox.nativeElement.contentWindow) {
			this.instaBox.nativeElement.style.height = event.data.height + 'px';
		}
	}

	onChartClick(event: any) {
		// console.log(event);
	}

	// slideNext() {
	// 	this.swiper?.swiperRef.slideNext(100);
	// }

	// slidePrev() {
	// 	this.swiper?.swiperRef.slidePrev(100);
	// }

	// slideNextTwo() {
	// 	this.swiperTwo?.swiperRef.slideNext(100);
	// }

	// slidePrevTwo() {
	// 	this.swiperTwo?.swiperRef.slidePrev(100);
	// }

	// getPendingTasks(sections: any) {
	// 	if (sections?.length >= 1) {
	// 		for (let section of sections) {
	// 			if (section.type === 'menu') {
	// 				if (section.menu.length >= 1) {
	// 					this.getPendingTasks(section.menu);
	// 				}
	// 			} else if ((section.type === 'video' || section.type === 'quiz') && section.dfs < this.todaysDfs && !this.isSectionCompleted(section.sno, this.userProgress.sections)) {
	// 				this.pendingTasks.push(section);
	// 			}
	// 		}
	// 	}
	// }

	async openProgram(program: any) {
		const userId = localStorage.getItem('userId');
		// const progressId = userId + "_" + program.id;
		this.router.navigate(['programs'], {
			state: {
				progressId: program.id
			}
		});
	}

	async setInspirationalQuote() {
		const quotes = await this.dashboardService.getQuotes();
		this.randomQuote = quotes[Math.floor((Math.random() * (quotes.length - 1)))];

		const quoteBox = document.getElementById("quote-box");
		if (quoteBox) {
			// quoteBox.style.background = this.randomQuote.color;
		}

		const quoteBoxMObile = document.getElementById("quote-boxMobile");
		if (quoteBoxMObile) {
			// quoteBoxMObile.style.background = this.randomQuote.color;
		}

		const quoteBG = document.getElementById("quoteBG");
		if (quoteBG) {
			// quoteBG.style.background = this.randomQuote.color;
		}
	}

	isSectionCompleted(sectionNo: number, sections: any): boolean {
		return this.sharedService.isSectionCompleted(sectionNo, sections);
	}

	getLearningHrs(learningDuration: any) {
		return this.sharedService.secondsToHours(learningDuration);
	}

	getTotalNumberOfSections(sections: any) {
		return this.sharedService.getTotalNumberOfSections(sections);
	}

	getPendingVideos(sections: any) {
		return this.sharedService.getPendingVideos(sections);
	}

	getPendingQuizzes(sections: any) {
		return this.sharedService.getPendingQuizzes(sections);
	}

	getRemainingDaysThisMonth() {
		return this.sharedService.getRemainingDaysThisMonth();
	}

	totalDaysThisMonth() {
		return this.sharedService.totalDaysThisMonth();
	}

	getDaysInRow(daysInRow: any) {
		return this.sharedService.getDaysInRow(daysInRow);
	}

	getLearningMinutesThisMonth(learningHistory: any) {
		if (learningHistory) {
			const seconds = this.sharedService.getLearningMinutesThisMonth(learningHistory);
			return Math.ceil(Number(this.sharedService.secondsToMinutes(seconds)));
		}

		return 0;
	}

	getLearningMinutesOverall(sections: any) {
		if (sections) {
			const seconds = this.sharedService.getLearningMinutesOverall(sections);
			return Number(this.sharedService.secondsToMinutes(seconds));
		}

		return 0;
	}

	getDaysLoggedThisMonth(daysLoggedHistory: any) {
		if (daysLoggedHistory) {
			return this.sharedService.getDaysLoggedThisMonth(daysLoggedHistory);
		}

		return 0;
	}

	// setTargetDateLabels(daysLogged: any) {
	// 	const currDate = new Date();
	// 	const currentMonth = currDate.getMonth();

	// 	for (let i = 1; i <= this.months[currentMonth]; i += 1) {
	// 		let dateStr = (i < 10 ? "0" + i : i) + "-" + (Number(currentMonth + 1) < 10 ? "0" + Number(currentMonth + 1) : Number(currentMonth + 1)) + "-" + currDate.getFullYear();

	// 		if (daysLogged && daysLogged.includes(dateStr)) {
	// 			this.targetDateLabels.push({
	// 				isDateLogged: true
	// 			});
	// 		} else {
	// 			this.targetDateLabels.push({
	// 				isDateLogged: false
	// 			});
	// 		}
	// 	}
	// }

	instagramContainerHeight() {
		// const element = document.getElementById("coming-soon-box");
		// if (element) {
		// 	const width = element.offsetWidth;
		// 	const height = width;

		// 	element.style.height = `${height}px`;
		// }

		// const newElement = document.getElementById("Insta-box");
		// if (newElement) {
		// 	const width = newElement.offsetWidth;
		// 	const height = width;

		// 	newElement.style.height = `${height}px`;
		// }
	}

	setInstaMObileHeight() {
		const newElement = document.getElementById("InstaBox");
		if (newElement) {
			const width = newElement.offsetWidth;
			// console.log('insta width', width)
			const height = width;

			newElement.style.height = `${height}px`;
		}
	}

	activeProgramComment(progress: any) {
		if (progress === 0) {
			return "It's quiet in here!";
		} else if (progress >= 1 && progress <= 39) {
			return "Here we go!";
		} else if (progress >= 40 && progress <= 50) {
			return "Almost halfway!";
		} else if (progress >= 51 && progress <= 80) {
			return "On the downhill!";
		} else if (progress >= 81 && progress <= 99) {
			return "So close!";
		} else if (progress === 100) {
			return "You DID it!";
		}
	}

	showCurrentMonthDates(date?: Date) {
		if (!this.targetCalendar) {
			setTimeout(() => {
				this.showCurrentMonthDates();
			}, 500);
			return;
		}

		let currentDate: Date;
		if (!date) {
			currentDate = new Date();
		} else {
			currentDate = date;
		}

		const currentMonthString = String(currentDate.getMonth() + 1 <= 9 ? "0" + String(currentDate.getMonth() + 1) : currentDate.getMonth() + 1) + "-" + String(currentDate.getFullYear());

		let targetDates = [];
		let allDaysHistory = [];
		// console.log(this.activePrograms);
		for (let program of this.activePrograms) {
			const daysLoggedHistory = program?.daysLoggedHistory;

			if (daysLoggedHistory) {
				for (let monthKey in daysLoggedHistory) {
					allDaysHistory.push(...daysLoggedHistory[monthKey]);
				}

				if (daysLoggedHistory[currentMonthString]) {
					const daysLoggedCurrentMonth = daysLoggedHistory[currentMonthString];

					for (const date of daysLoggedCurrentMonth) {
						const [dateNum, dateMonth, dateYear] = date.split("-");
						const dateObj = new Date(dateYear, dateMonth - 1, dateNum);
						targetDates.push(dateObj);
					}

					this.targetCalendar.specialDates = [{
						type: DateRangeType.Specific,
						dateRange: targetDates
					}];
				}
			}

			if (program?.completedAt) {
				let completedAtDate: Date | null = null;
				if (program.completedAt?.toDate) {
					completedAtDate = new Date(program.completedAt.toDate());
				} else if (program.completedAt?.seconds) {
					completedAtDate = new Date(program.completedAt.seconds * 1000);
				} else if (program.completedAt?._seconds) {
					completedAtDate = new Date(program.completedAt._seconds * 1000);
				} else {
					completedAtDate = new Date(program.completedAt);
				}

				if (completedAtDate && !isNaN(completedAtDate.getTime())) {
					targetDates.push(completedAtDate);
				}
			}
		}

		if (this.userData && this.userData.podcastsProgress) {
			let podcastsProgress = this.userData.podcastsProgress;

			for (let item of podcastsProgress) {
				if (item.completedAt) {
					if (item.completedAt.toDate) {
						let dateObj = new Date(item.completedAt.toDate());
						targetDates.push(dateObj);
					} else if (item.completedAt.seconds) {
						let dateObj = new Date(item.completedAt.seconds * 1000);
						targetDates.push(dateObj);
					} else {
						let dateObj = new Date(item.completedAt);
						targetDates.push(dateObj);
					}
				}
			}
		}

		if (this.userData && this.userData.miniClipsData && this.userData.miniClipsData.length >= 1) {
			let mcData = this.userData.miniClipsData;

			for (let item of mcData) {
				let data = item.miniClipData;

				for (let clip of data) {
					if (clip.completed && clip.completedAt) {
						if (clip.completedAt.toDate) {
							let dateObj = new Date(clip.completedAt.toDate());
							targetDates.push(dateObj);
						} else if (clip.completedAt.seconds) {
							let dateObj = new Date(clip.completedAt.seconds * 1000);
							targetDates.push(dateObj);
						} else {
							let dateObj = new Date(clip.completedAt);
							targetDates.push(dateObj);
						}
					}
				}
			}
		}

		// console.log(targetDates);
		let dd = this.getDisabledDates(allDaysHistory);
		const sortedDates = allDaysHistory.map(dateString => moment(dateString, "DD-MM-YYYY").toDate()).sort((a: any, b: any) => a - b);

		const allDaysHistorySorted = sortedDates.map((date: any) => moment(date).format("DD-MM-YYYY"));
		let continuousDates = this.findContinuousDates(allDaysHistorySorted);
		// console.log(continuousDates);
		const disabledDates = [...dd, ...continuousDates];

		this.targetCalendar.specialDates = [{
			type: DateRangeType.Specific,
			dateRange: targetDates
		}];

		this.targetCalendar.disabledDates = [{
			type: DateRangeType.Specific,
			dateRange: disabledDates
		}];
	}

	getDisabledDates(allDaysHistory: any) {
		let disabledDates = [];
		let currDate = this.currentDate.toDate();
		let currDateFmt = this.currentDate.format("DD-MM-Y");
		let prevDates = this.sharedService.getPreviousDates(7);

		if (allDaysHistory.includes(currDateFmt) && allDaysHistory.includes(prevDates[0].fmt) && allDaysHistory.includes(prevDates[1].fmt) && allDaysHistory.includes(prevDates[2].fmt) && allDaysHistory.includes(prevDates[3].fmt)) {
			let dates = [currDate, prevDates[0].date, prevDates[1].date, prevDates[2].date, prevDates[3].date];
			disabledDates.push(...dates);
		}
		if (allDaysHistory.includes(prevDates[0].fmt) && allDaysHistory.includes(prevDates[1].fmt) && allDaysHistory.includes(prevDates[2].fmt) && allDaysHistory.includes(prevDates[3].fmt) && allDaysHistory.includes(prevDates[4].fmt)) {
			let dates = [currDate, prevDates[0].date, prevDates[1].date, prevDates[2].date, prevDates[3].date, prevDates[4].date];
			disabledDates.push(...dates);
		}
		if (allDaysHistory.includes(prevDates[1].fmt) && allDaysHistory.includes(prevDates[2].fmt) && allDaysHistory.includes(prevDates[3].fmt) && allDaysHistory.includes(prevDates[4].fmt) && allDaysHistory.includes(prevDates[5].fmt)) {
			let dates = [currDate, prevDates[0].date, prevDates[1].date, prevDates[2].date, prevDates[3].date, prevDates[4].date, prevDates[5].date];
			disabledDates.push(...dates);
		}
		if (allDaysHistory.includes(prevDates[2].fmt) && allDaysHistory.includes(prevDates[3].fmt) && allDaysHistory.includes(prevDates[4].fmt) && allDaysHistory.includes(prevDates[5].fmt) && allDaysHistory.includes(prevDates[6].fmt) && allDaysHistory.includes(currDateFmt)) {
			let dates = [currDate, prevDates[0].date, prevDates[1].date, prevDates[2].date, prevDates[3].date, prevDates[4].date, prevDates[5].date, prevDates[6].date];
			disabledDates.push(...dates);
		}

		return disabledDates;
	}

	getStreaks(daysInRow: any) {
		if (daysInRow) {
			return Math.floor(daysInRow / 5);
		}

		return 0;
	}

	getDosesCompleted() {
		let dosesCompleted = 0;
		if (this.activePrograms.length >= 1) {
			for (let program of this.activePrograms) {
				if (program.dosesCompleted && Object.keys(program.dosesCompleted).length >= 1) {
					for (let monthKey of Object.keys(program.dosesCompleted)) {
						const doses = program.dosesCompleted[monthKey];
						for (let dateKey of Object.keys(doses)) {
							dosesCompleted += doses[dateKey];
						}
					}
				}
			}
		}

		if (this.userData && this.userData.miniClipsData && this.userData.miniClipsData.length >= 1) {
			let mcData = this.userData.miniClipsData;

			for (let item of mcData) {
				let data = item.miniClipData;

				for (let clip of data) {
					if (clip.completed) {
						dosesCompleted += 1;
					}
				}
			}
		}

		if (this.userData && this.userData.podcastsProgress && this.userData.podcastsProgress.length >= 1) {
			let podcastsProgress = this.userData.podcastsProgress;

			for (let item of podcastsProgress) {
				if (item.progress === 100) {
					dosesCompleted += 1;
				}
			}
		}

		return dosesCompleted;
	}

	getDosesCompletedThisMonth() {
		let dosesCompleted = 0;
		if (this.activePrograms.length >= 1) {
			for (let program of this.activePrograms) {
				if (program.dosesCompleted && program.dosesCompleted[this.currentMonth]) {
					const doses = program.dosesCompleted[this.currentMonth];
					for (let key of Object.keys(doses)) {
						dosesCompleted += doses[key];
					}
				}
			}
		}

		if (this.userData && this.userData.miniClipsData && this.userData.miniClipsData.length >= 1) {
			let mcData = this.userData.miniClipsData;

			for (let item of mcData) {
				let data = item.miniClipData;

				for (let clip of data) {
					if (clip.completed && clip.completedAt && this.getMonthOfDate(clip.completedAt) === this.currentMonth) {
						dosesCompleted += 1;
					}
				}
			}
		}

		if (this.userData && this.userData.podcastsProgress && this.userData.podcastsProgress.length >= 1) {
			let podcastsProgress = this.userData.podcastsProgress;

			for (let item of podcastsProgress) {
				if (item.progress === 100 && item.completedAt && this.getMonthOfDate(item.completedAt) === this.currentMonth) {
					dosesCompleted += 1;
				}
			}
		}

		if (dosesCompleted >= 1) {
			return dosesCompleted;
		}
		return dosesCompleted;
	}

	getFirstPendingSection(sections: any): any {
		if (sections?.length >= 1) {
			for (let section of sections) {
				if (section.type === 'menu') {
					const firstPendingSection = this.getFirstPendingSection(section.menu);

					if (firstPendingSection && Object.keys(firstPendingSection).length >= 1) {
						return firstPendingSection;
					} else {
						continue;
					}
				} else if (section.progress !== 100) {
					return section;
				}
			}
		}
	}

	getLastSection(sections: any): any {
		let lastSection: any;

		if (sections?.length >= 1) {
			for (let section of sections) {
				if (section.type === 'menu') {
					const lastSec = this.getLastSection(section.menu);
					lastSection = lastSec;
				} else {
					lastSection = section;
				}
			}
		}

		return lastSection;
	}

	getQuizzesCompleted() {
		let quizzesCompleted = 0;
		if (this.activePrograms.length >= 1) {
			for (let program of this.activePrograms) {
				const totalQuizzes = program.totalQuizzes;
				const quizProgress = program.quizProgress;

				quizzesCompleted += Math.round((quizProgress / 100) * totalQuizzes);
			}
		}

		return quizzesCompleted;
	}

	changeState(): void {
		// (this.state == "closed") ? this.state = "open" : this.state = "closed";
		// (this.state == "closed") ? this.state = "open" : this.state = "closed";
		window.scroll({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});

		if (this.state == "closed") {
			this.posthog.capture(POSTHOG_EVENT_DAILY_DOSE_DOC, {
				'User email': localStorage.getItem('username'),
				'device_type': this.deviceDetectorService.device,
				'role': localStorage.getItem('roleId')
			});
			this.state = "open"
			document.body.style.overflow = 'hidden';
		} else {
			this.state = "closed"
			document.body.style.overflow = 'auto';
		}
	}

	getProgramsCompleted() {
		let count = 0;
		for (let program of this.activePrograms) {
			if (program.progress === 100) {
				count += 1;
			}
		}
		return count;
	}

	letsGoDailyDose() {
		this.posthog.capture(POSTHOG_EVENT_DAILY_DOSE_LETS_GO, {
			'User email': localStorage.getItem('username'),
			'device_type': this.deviceDetectorService.device,
			'role': localStorage.getItem('roleId')
		});

		if (this.activePrograms.length >= 1) {
			// go to most recent active program here
			this.router.navigate(['programs'], {
				state: {
					progressId: this.activePrograms[0].id
				}
			});
		} else {
			this.router.navigate(['my-library']);
		}
	}

	setCircleProgressDimensions() {
		const viewportWidth = window.innerWidth || document?.documentElement?.clientWidth;
		const circleProgressElement = this.elRef?.nativeElement?.querySelector('.circle-progress');
		const circleProgressSize = viewportWidth < 900 ? 50 : 500;

		if (circleProgressElement) {
			this.renderer.setStyle(circleProgressElement, 'width', `${circleProgressSize}px`);
			this.renderer.setStyle(circleProgressElement, 'height', `${circleProgressSize}px`);
		}
	}

	addSlide() {
		this.slides.push({ img: "http://placehold.it/350x150/777777" })
	}

	removeSlide() {
		this.slides.length = this.slides.length - 1;
	}

	slickInit(e: any) {
		// console.log('slick initialized');
	}

	breakpoint(e: any) {
		// console.log('breakpoint');
	}

	afterChange(e: any) {
		// console.log('afterChange');
	}

	beforeChange(e: any) {
		// console.log('beforeChange');
	}

	getRadius(): any {
		if (window.innerWidth <= 380) {
			return 39;
		} else if ((window.innerWidth >= 380 && window.innerWidth <= 900)) {
			return 47;
		} else {
			return 60;
		}
	}

	getSpace(): any {
		if (window.innerWidth <= 380) {
			return -8;
		} else if ((window.innerWidth >= 380 && window.innerWidth <= 900)) {
			return -14;
		} else {
			return -18.9;
		}
	}

	getOuterStrokeWidth(): any {
		if (window.innerWidth <= 380) {
			return 10;
		} else if ((window.innerWidth >= 380 && window.innerWidth <= 900)) {
			return 16;
		} else {
			return 19;
		}
	}

	getInnerStrokeWidth(): any {
		if (window.innerWidth <= 380) {
			return 6;
		} else if ((window.innerWidth >= 380 && window.innerWidth <= 900)) {
			return 10;
		} else {
			return 13;
		}
	}

	getTitleFontSize(): any {
		if (window.innerWidth <= 350) {
			return 21;
		} else if ((window.innerWidth >= 350 && window.innerWidth <= 900)) {
			return 24;
		} else {
			return 24;
		}
	}

	@HostListener('window:resize')
	onWindowResize() {
		// Call getRadius() whenever the window is resized
		this.getRadius();
		this.getOuterStrokeWidth();
		this.getInnerStrokeWidth();
		this.getSpace();
		this.getTitleFontSize();
	}

	isAnyProgramInProgress() {
		for (let program of this.activePrograms) {
			if (program.progress !== 100) {
				return true;
			}
		}

		return false;
	}

	isAnyProgramComplete() {
		for (let program of this.activePrograms) {
			if (program.progress === 100) {
				return true;
			}
		}

		return false;
	}

	getFormattedCourseTime(courseTime: any) {
		return this.sharedService.getFormattedCourseTime(courseTime);
	}

	sortActiveProgramsByAccessOrder() {
		this.activePrograms.sort(function sortByAccessOrder(programA: any, programB: any) {
			if (programA.lastUpdatedAt > programB.lastUpdatedAt) {
				return -1;
			} else if (programA.lastUpdatedAt < programB.lastUpdatedAt) {
				return 1;
			}

			return 0;
		});
	}

	onTouchStart(event: TouchEvent): void {
		this.touchStartX = event.touches[0].clientX;
	}

	onTouchMove(event: TouchEvent): void {
		this.touchEndX = event.touches[0].clientX;
	}

	onTouchEnd(): void {
		const deltaX = this.touchEndX - this.touchStartX;

		if (deltaX > this.touchThreshold && this.currentIndex > 0) {
			this.goToSlide(this.currentIndex - 1);
		} else if (deltaX < -this.touchThreshold && this.currentIndex < this.slides.length - 1) {
			this.goToSlide(this.currentIndex + 1);
		}
	}

	getSectionsCompleted() {
		let count = 0;
		for (let program of this.activePrograms) {
			if (program.sections?.length >= 1) {
				for (let section of program.sections) {
					let isSectionCompleted = true;

					if (section.menu) {
						for (let unit of section.menu) {
							if (unit.progress !== 100) {
								isSectionCompleted = false;
								break;
							}
						}
					}

					if (isSectionCompleted) {
						count += 1;
					}
				}
			}
		}
		return count;
	}

	getActiveProgramsMessage() {
		if (this.activePrograms.length >= 1) {
			const progress = this.activePrograms[0].progress;

			if (progress === 0) {
				return "It's quiet in here!";
			} else if (progress >= 1 && progress <= 39) {
				return "Here we go!";
			} else if (progress >= 40 && progress <= 50) {
				return "Almost halfway!";
			} else if (progress >= 51 && progress <= 80) {
				return "On the downhill!";
			} else if (progress >= 81 && progress <= 99) {
				return "So close!";
			} else {
				return "You DID it!";
			}
		}

		return "";
	}

	getDoseAlgoRes() {
		if (this.dosesCompletedThisMonth === 0) {
			return "D.O.S.E Up";
		} else if (this.dosesCompletedThisMonth >= 1 && this.dosesCompletedThisMonth <= 10) {
			return "D.O.S.E Dabbler";
		} else if (this.dosesCompletedThisMonth >= 11 && this.dosesCompletedThisMonth <= 15) {
			return "D.O.S.E Doer";
		} else if (this.dosesCompletedThisMonth >= 16 && this.dosesCompletedThisMonth <= 20) {
			return "D.O.S.E Hero";
		} else if (this.dosesCompletedThisMonth >= 21 && this.dosesCompletedThisMonth <= 30) {
			return "D.O.S.E Star";
		} else if (this.dosesCompletedThisMonth >= 31 && this.dosesCompletedThisMonth <= 40) {
			return "D.O.S.E Expert";
		} else {
			return "D.O.S.E Master";
		}
	}

	async updateLoginTime(userData: any) {
		if (userData.loginHistory && Object.keys(userData.loginHistory).length >= 1) {
			if (userData.loginHistory[this.currentMonth]) {
				userData.loginHistory[this.currentMonth] = this.loginTime;
			}
		} else {
			userData.loginHistory = {};
			userData.loginHistory[this.currentMonth] = this.loginTime;
		}
		// await this.dashboardService.updateLoginTime(this.userId, userData.loginHistory);

		setTimeout(async () => {
			this.loginTime += 5;
			await this.updateLoginTime(userData);
		}, 5000);
	}

	navigateToPage(path: string) {
		this.router.navigate([path]);
	}

	setNewVisitorIntroduction() {
		const isNewVisitor = localStorage.getItem('newVisitorIntroduction');
		// console.log('isNewVisitor', typeof isNewVisitor)
		localStorage.setItem('newVisitorIntroduction', isNewVisitor ? 'false' : 'true');
	}

	closeIntroVideo() {
		this.newVisitorIntroduction = 'false'
	}

	onVideoEnded() {
		this.hideIntroVideo = true;
	}

	openIntroVideoModal() {
		const diaogRef = this.dialogRef.open(IntroVideoModalComponent, {
			maxWidth: '80vw',
			minWidth: 'fit-content',
			height: '68vh'
		});
	}

	openMiniclipsModal() {
		// console.log('test');
		const diaogRef = this.dialogRef.open(MiniclipsModalComponent, {
			width: '62vw',
			panelClass: 'custom-modal',
			// minWidth: 'fit-content',
		});
	}

	openPodcastModal() {
		const diaogRef = this.dialogRef.open(MiniclipsModalComponent, {
			width: '62vw',
			panelClass: 'custom-modal',
			// minWidth: 'fit-content',
		});
	}

	async getMiniClipCoverImage() {
		// console.log("Loading gif...")
		const miniClipCoverImage = await this.dashboardService.getMiniClipCoverImage();
		this.miniClipCoverImage = miniClipCoverImage?.gifPath;
	}

	showEmojis(type: any) {
		if (type === 'podcast') {
			this.showEmojiTab = !this.showEmojiTab;
			this.showEmojiTab2 = false;
			this.showEmojiTab3 = false;
		}
		if (type === 'miniClip') {
			this.showEmojiTab3 = !this.showEmojiTab3;
			this.showEmojiTab = false;
			this.showEmojiTab2 = false;
		}
		if (type === 'quote') {
			this.showEmojiTab2 = !this.showEmojiTab2;
			this.showEmojiTab = false;
			this.showEmojiTab3 = false;
		}
	}

	async getLikesData() {
		this.allLikesData = []
		this.likesService.getLikes().subscribe(async data => {
			this.allLikesData = data
			data.forEach((emojidata: any) => {
				// console.log('emojidata', emojidata)
				// console.log('this.userId', this.userId)
				if (emojidata.userId === this.userId && emojidata.entityType === "podcast") {
					this.selectedPodcastEmojiType = emojidata.emotionType;
					// console.log('selectedPodcastEmojiType', this.selectedPodcastEmojiType)
				}

				if (emojidata.userId === this.userId && emojidata.entityType === "quote") {
					this.selectedQuoteEmojiType = emojidata.emotionType;
					// console.log('selectedQuoteEmojiType', this.selectedQuoteEmojiType)
				}

				if (emojidata.userId === this.userId && emojidata.entityType === "miniClip") {
					this.selectedMiniClipEmojiType = emojidata.emotionType;
					// console.log('selectedMiniClipEmojiType', this.selectedMiniClipEmojiType)
				}
			});
		})
	}

	handleEmojiClick(emojiData: any, entityId: any, entityType: any) {
		// console.log('entityId', entityId)
		if (entityType === 'podcast') {
			if (this.highlightedPodcastEmojiType === emojiData.emotionType) {
				this.selectedPodcastEmojiType = null;
				this.highlightedPodcastEmojiType = null;
			} else {
				this.selectedPodcastEmojiType = emojiData.emotionType;
				this.highlightedPodcastEmojiType = null;
				setTimeout(() => {
					this.highlightedPodcastEmojiType = emojiData.emotionType;
				}, 1000);
			}
			// console.log('podcast')
			// console.log('allLikesData', this.allLikesData)
			if (this.allLikesData?.length) {
				this.allLikesData.forEach((data: any) => {
					// console.log('data', data)
					if (data.userId == this.userId && data.entityId == "podcast") {
						this.selectedPodcastEmojiType = emojiData.emotionType
						data.emotionType = this.selectedPodcastEmojiType
						this.likesService.updateLike(data, data.id)
					}
				});
			}
			else {
				const data: any = {
					emotionType: emojiData.emotionType,
					userId: this.userId,
					entityType: entityType,
					entityId: entityId,
					userName: this.username,
					createdAt: new Date()
				}

				this.likesService.addLike(data, '')
				// console.log('add')
			}

			this.selectedPodcastEmojiType = emojiData.emotionType;
			this.highlightedPodcastEmojiType = emojiData.emotionType
		}

		// for quote
		if (entityType === 'quote') {
			// console.log('quote')
			if (this.highlightedQuoteEmojiType === emojiData.emotionType) {
				this.selectedQuoteEmojiType = null;
				this.highlightedQuoteEmojiType = null;
			} else {
				this.selectedQuoteEmojiType = emojiData.emotionType;
				this.highlightedQuoteEmojiType = null;
				setTimeout(() => {
					this.highlightedQuoteEmojiType = emojiData.emotionType;
				}, 1000);
			}
			// console.log('quote')
			// console.log('allLikesData', this.allLikesData)

			let updateData: any = false;
			let addData: any = true;

			if (this.allLikesData?.length) {
				this.allLikesData.forEach((data: any) => {
					// console.log('data', data)
					if (data.userId === this.userId && data.entityId === entityId) {
						// console.log('update')
						this.selectedQuoteEmojiType = emojiData.emotionType
						data.emotionType = this.selectedQuoteEmojiType
						this.likesService.updateLike(data, data.id)
						updateData = true
						addData = false
					}
				});

				if (addData) {
					const newData: any = {
						emotionType: emojiData.emotionType,
						userId: this.userId,
						entityType: entityType,
						entityId: entityId,
						userName: this.username,
						createdAt: new Date()
					}

					this.likesService.addLike(newData, '')
					// console.log('add')
				}
			}

			this.selectedQuoteEmojiType = emojiData.emotionType;
			this.highlightedQuoteEmojiType = emojiData.emotionType
		}

		// for miniclips
		if (entityType === 'miniClip') {
			// console.log('miniClip')
			if (this.highlightedMiniClipEmojiType === emojiData.emotionType) {
				this.selectedMiniClipEmojiType = null;
				this.highlightedMiniClipEmojiType = null;
			} else {
				this.selectedMiniClipEmojiType = emojiData.emotionType;
				this.highlightedMiniClipEmojiType = null;
				setTimeout(() => {
					this.highlightedMiniClipEmojiType = emojiData.emotionType;
				}, 1000);
			}
			// console.log('MiniClip')
			// console.log('allLikesData', this.allLikesData)

			let updateData: any = false;
			let addData: any = true;

			if (this.allLikesData?.length) {
				this.allLikesData.forEach((data: any) => {
					// console.log('data', data)
					if (data.userId === this.userId && data.entityId === entityId) {
						// console.log('update')
						this.selectedMiniClipEmojiType = emojiData.emotionType
						data.emotionType = this.selectedMiniClipEmojiType
						this.likesService.updateLike(data, data.id)
						updateData = true
						addData = false
					}
				});

				if (addData) {
					const newData: any = {
						emotionType: emojiData.emotionType,
						userId: this.userId,
						entityType: entityType,
						entityId: entityId,
						userName: this.username,
						createdAt: new Date()
					}

					this.likesService.addLike(newData, '')
					// console.log('add')
				}
			}

			this.selectedMiniClipEmojiType = emojiData.emotionType;
			this.highlightedMiniClipEmojiType = emojiData.emotionType
		}
	}

	getMonthOfDate(date: any) {
		if (date) {
			let newDate: any;
			if (date.seconds && date.nanoseconds) {
				newDate = new Date(date.seconds * 1000);
			} else if (date._seconds && date._nanoseconds) {
				newDate = new Date(date._seconds * 1000);
			}
			const month = (newDate.getMonth() + 1) < 10 ? "0" + newDate.getMonth() + 1 : String(newDate.getMonth() + 1);
			// console.log(newDate);
			const year = newDate.getFullYear();
			return `${month}-${year}`;
		}

		return "";
	}

	mHeight: number = 350;
	cardImageElemRef: any;

	mDesktopHeight: number = 350;
	desktopCardImageElemRef: any;

	onImageLoad(cardElement: HTMLImageElement) {
		if (cardElement) {
			this.getImageDimensions(cardElement);
			this.cardImageElemRef = cardElement;
		}
	}

	onDesktopImageLoad(desktopCardImage: HTMLImageElement) {
		this.getDesktopImageDimensions(desktopCardImage);
		this.desktopCardImageElemRef = desktopCardImage;
	}

	@HostListener('window:resize', ['$event'])
	async onResize(event: any) {
		this.getImageDimensions(this.cardImageElemRef);
		this.getDesktopImageDimensions(this.desktopCardImageElemRef);
		await this.onDeviceWidthChange();
		this.adjustWaveSurferOptions();
		this.adjustCustomWaveSurferBarsLength();
		if ((this.currentPipValue === 'maximize' || this.currentPipValue === 'open') && window.innerWidth < 500) {
			const bottomSheetConfig: MatBottomSheetConfig = {
				panelClass: 'mobile-podcast',
				data: {
					isOpen: true,
					podcasts: this.podcasts,
					likesData: this.likesIdData,
					commentsData: this.commentsIdData,
					audioUrls: this.audioUrls,
					userId: this.userId,
					userData: this.userData,
				}
			};
			this._bottomSheet.open(MobilePodcastComponent, bottomSheetConfig);
		}
		// this.getPrgNameHeight();
	}

	getImageDimensions(cardElement: any) {
		const width = cardElement.width;
		const height = cardElement.height;
		if (height) this.mHeight = height;
	}

	getDesktopImageDimensions(desktopCardImage: any) {
		const width = desktopCardImage.width;
		const height = desktopCardImage.height;
		// console.log('desktopCardImage', height)
		if (height) this.mDesktopHeight = height;
	}

	// getPrgNameHeight() {
	//     setTimeout(() => {
	//         this.prgNameHeight = this.myElement?.nativeElement.offsetHeight;
	// 		// console.log('prgNameHeight', this.prgNameHeight)
	//     }, 1000);
	// }

	isDoseDetailsOpen: boolean = false;
	isMoreDetailsOpen: boolean = false;
	isCommentBoxOpen: boolean = false;
	isLiked: boolean = false;
	isComment: boolean = false;

	openPodcastSlide() {
		if (this.podcasts.length >= 2) {
			if (this.currentPipValue !== 'minimize' && this.currentPipValue !== 'maximize') {
				if (this.currentPipValue !== 'open') {
					this.likesService.setPIPValue('open');
				} else {
					this.likesService.setPIPValue('close');
					if (this.wavesurfer) {
						if (this.isPlaying) {
							this.wavesurfer.pause();
						}
					}
				}
				this.allBottomSheetClose();
			} else if (this.currentPipValue === 'maximize') {
				this.closePodcastSlide();
			}
		}
	}

	closePodcastSlide() {
		this.likesService.setPIPValue('close');
		this.wavesurfer?.pause();
		this.likesService.playValueSubject.next(this.isPlaying);
		this.allBottomSheetClose();
	}

	minimizePodcastSlide() {
		this.likesService.setPIPValue('minimize');
		this.likesService.currentTimeValue.next(this.wavesurfer?.getCurrentTime());
		// this.isPodcastSlideOpen = false;
		localStorage.setItem("playingState", String(this.isPlaying));
		setTimeout(() => {
			localStorage.removeItem("playingState");
		}, 3000);
		this.wavesurfer?.pause();
		this.allBottomSheetClose();
	}

	allBottomSheetClose() {
		this.isDoseDetailsOpen = false;
		this.isMoreDetailsOpen = false;
		this.isCommentBoxOpen = false;
	}

	toggleDoseDetails() {
		this.isDoseDetailsOpen = !this.isDoseDetailsOpen;
		if (this.isMoreDetailsOpen) this.isMoreDetailsOpen = false;
		if (this.isCommentBoxOpen) this.isCommentBoxOpen = false;
	}

	toggleMoreDetails() {
		this.isMoreDetailsOpen = !this.isMoreDetailsOpen;
		if (this.isDoseDetailsOpen) this.isDoseDetailsOpen = false;
		if (this.isCommentBoxOpen) this.isCommentBoxOpen = false;
	}

	toggleCommentBox() {
		this.isCommentBoxOpen = !this.isCommentBoxOpen;
		if (this.isDoseDetailsOpen) this.isDoseDetailsOpen = false;
		if (this.isMoreDetailsOpen) this.isMoreDetailsOpen = false;
	}

	async toggleIsLiked() {
		this.isLiked = !this.isLiked;
		const entityId = `${this.selectedPodcastSeason}_${this.selectedPodcastEpisode}`;

		const data = {
			entityType: "podcast",
			userId: this.userId,
			userName: "",
			emotionType: "like",
			entityId,
			createdAt: new Date()
		};

		if (this.isLiked) {
			this.likeDocId = await this.likesService.addLike(data, "");
			this.posthog.capture(POSTHOG_EVENT_FAVOURITE_DAILY_DOSE, {
				'user email': localStorage.getItem('username'),
				'poadcast name': this.selectedPodcast?.title,
				'device_type': this.deviceDetectorService.device,
				'role': localStorage.getItem('roleId'),
				'date': new Date()
			});
		} else {
			await this.likesService.removeLike(this.likeDocId);
			this.likeDocId = "";
		}
	}

	skipBackwardFn() {
		this.checkIfAudioIsLoading();

		if (this.wavesurfer) {
			const currentTime = this.wavesurfer.getCurrentTime();
			const newTime = Math.max(0, currentTime - 10);
			this.wavesurfer.seekTo(newTime / this.durationTime);
		}
	}

	skipForwardFn() {
		this.checkIfAudioIsLoading();

		if (this.wavesurfer) {
			const currentTime = this.wavesurfer.getCurrentTime();
			const newTime = Math.min(this.durationTime, currentTime + 10);
			this.wavesurfer.seekTo(newTime / this.durationTime);
		}
	}

	toggleMute() {
		this.checkIfAudioIsLoading();

		if (this.wavesurfer) {
			this.isMuted = !this.isMuted; // Toggle the mute state

			if (this.isMuted) {
				this.wavesurfer.setMuted(true);
			} else {
				this.wavesurfer.setMuted(false);
			}
		}
	}

	changeVolume(volume: number) {
		const normalizedVolume = volume / 100;
		if (this.wavesurfer) {
			this.wavesurfer.setVolume(normalizedVolume);
		}
	}

	async onUrlChange(index: number, shouldPlay: boolean) {
		if (shouldPlay) {
			await this.spinner.show("blockLoader");
			index += 1;
			// console.log(index);

			this.urlIndex = index;
			this.adjustWaveSurferOptions();

			if (this.wavesurfer && this.waveformElement) {
				try {
					this.isLoadingWavesurfer = true;
					this.wavesurfer.destroy();
					this.wavesurfer = WaveSurfer.create({
						container: this.waveformElement.nativeElement,
						height: 40,
						barWidth: 3,
						barGap: 3,
						waveColor: '#fff',
						progressColor: '#7881E6',
						fetchParams: {
							mode: "no-cors",
						}
					});

					this.wavesurfer?.on('play', async () => {
						this.isPlaying = true;
						this.likesService.playValueSubject.next(this.isPlaying);
						await this.watchPlayEvent();
					});
					this.wavesurfer?.on('pause', () => {
						this.isPlaying = false;
						this.likesService.playValueSubject.next(this.isPlaying);
					});
					this.wavesurfer?.on('interaction', () => this.skipForwardFn());
					this.wavesurfer?.on('interaction', () => this.skipBackwardFn());
					// this.wavesurfer?.on('ready', () => this.durationTime = this.wavesurfer?.getDuration());
					this.wavesurfer?.on('audioprocess', () => {
						const currentTime = this.wavesurfer?.getCurrentTime();
						this.currentTime = currentTime;

						if (currentTime !== undefined) {
							this.likesService.currentTimeValue.next(currentTime);
							let progress = Number(Number((currentTime * 100 / this.durationTime) / 100).toFixed(2));
							let entityId = `${this.selectedPodcast.season_number}_${this.selectedPodcast.episode_number}`;
							let index = this.podcasts.findIndex((p: any) => {
								let podcastId = `${p.season_number}_${p.episode_number}`;
								return podcastId === entityId;
							});
							this.wavesProgress[index] = progress;
						}
					});
					this.wavesurfer?.on('seeking', () => {
						this.currentTime = this.wavesurfer!.getCurrentTime();
					});

					this.wavesurfer.load(this.podcasts[index].audio_url);
				} catch (err) {
					console.log("Unable to load podcast change audio.", err);
				} finally {
					this.isLoadingWavesurfer = false;
				}

				this.selectedPodcast = this.podcasts[index];
				this.likesService.selectedPodcastValue.next(this.selectedPodcast);
				this.selectedPodcastSeason = this.selectedPodcast.season_number;
				this.selectedPodcastEpisode = this.selectedPodcast.episode_number;
				let likeDocId;
				const getEpisodeLike = this.likesIdData.findIndex((likeData: any) => {
					let entityId = `${this.selectedPodcastSeason}_${this.selectedPodcastEpisode}`;
					likeDocId = likeData.id;
					return likeData.entityId === entityId;
				});

				if (getEpisodeLike === -1) {
					this.isLiked = false;
					this.likeDocId = "";
				} else {
					this.isLiked = true;
					this.likeDocId = likeDocId;
				}

				let commentDocId;
				let commentText: any;
				const getEpisodeComment = this.commentsIdData.findIndex((commentData: any) => {
					let entityId = `${this.selectedPodcastSeason}_${this.selectedPodcastEpisode}`;
					commentDocId = commentData.id;
					commentText = commentData.text;
					return commentData.entityId === entityId;
				});

				if (getEpisodeComment === -1) {
					this.isComment = false;
					this.commentDocId = "";
					this.commentBoxText = "";
				} else {
					this.isComment = true;
					this.commentDocId = commentDocId;
					this.commentBoxText = commentText;
					this.commentCharacterCount = commentText.length;
				}

				this.durationTime = this.selectedPodcast.duration;
				if (this.wavesProgress[index] === 0 || this.wavesProgress[index] === 1) {
					this.currentTime = 0;
				} else {
					let progressPercentage = this.wavesProgress[index] * 100;
					this.currentTime = (progressPercentage * this.durationTime) / 100;
					this.wavesurfer.setTime(this.currentTime);
				}
				if (shouldPlay) {
					this.wavesurfer.play();
				}
			}
			await this.spinner.hide("blockLoader");
		} else {
			index += 1;

			this.urlIndex = index;
			this.wavesurfer?.setOptions({
				height: 40,
				barWidth: 3,
				barGap: 3,
				waveColor: '#fff',
				progressColor: '#7881E6',
			});

			if (this.wavesurfer) {
				try {
					this.isLoadingWavesurfer = true;
					await this.wavesurfer.load(this.audioUrls[this.urlIndex]);
				} catch (err) {
					console.log("Unable to load podcast change audio.");
				} finally {
					this.isLoadingWavesurfer = false;
				}

				this.wavesurfer?.on('play', async () => {
					this.isPlaying = true;
					this.likesService.playValueSubject.next(this.isPlaying);
					await this.watchPlayEvent();
				});
				this.wavesurfer?.on('pause', () => {
					this.isPlaying = false;
					this.likesService.playValueSubject.next(this.isPlaying);
				});
				this.wavesurfer?.on('interaction', () => this.skipForwardFn());
				this.wavesurfer?.on('interaction', () => this.skipBackwardFn());
				// this.wavesurfer?.on('ready', () => this.durationTime = this.wavesurfer?.getDuration());
				this.wavesurfer?.on('audioprocess', () => {
					const currentTime = this.wavesurfer?.getCurrentTime();
					this.currentTime = currentTime;

					if (currentTime !== undefined) {
						this.likesService.currentTimeValue.next(currentTime);
						let progress = Number(Number((currentTime * 100 / this.durationTime) / 100).toFixed(2));
						let entityId = `${this.selectedPodcast.season_number}_${this.selectedPodcast.episode_number}`;
						let index = this.podcasts.findIndex((p: any) => {
							let podcastId = `${p.season_number}_${p.episode_number}`;
							return podcastId === entityId;
						});
						this.wavesProgress[index] = progress;
					}
				});
				this.wavesurfer?.on('seeking', () => {
					this.currentTime = this.wavesurfer!.getCurrentTime();
				});
				this.currentTime = this.likesService.currentTimeValue.getValue();
				// console.log('currentTime...', this.currentTime)
				if (this.currentTime) {
					this.wavesurfer.setTime(this.currentTime)
				}
				this.selectedPodcast = this.podcasts[index];
				this.likesService.selectedPodcastValue.next(this.selectedPodcast);
				// console.log(this.selectedPodcast);
				this.selectedPodcastSeason = this.selectedPodcast.season_number;
				this.selectedPodcastEpisode = this.selectedPodcast.episode_number;
				let likeDocId;
				const getEpisodeLike = this.likesIdData.findIndex((likeData: any) => {
					let entityId = `${this.selectedPodcastSeason}_${this.selectedPodcastEpisode}`;
					likeDocId = likeData.id;
					return likeData.entityId === entityId;
				});

				if (getEpisodeLike === -1) {
					this.isLiked = false;
					this.likeDocId = "";
				} else {
					this.isLiked = true;
					this.likeDocId = likeDocId;
				}

				let commentDocId;
				let commentText: any;
				const getEpisodeComment = this.commentsIdData.findIndex((commentData: any) => {
					let entityId = `${this.selectedPodcastSeason}_${this.selectedPodcastEpisode}`;
					commentDocId = commentData.id;
					commentText = commentData.text;
					return commentData.entityId === entityId;
				});

				if (getEpisodeComment === -1) {
					this.isComment = false;
					this.commentDocId = "";
					this.commentBoxText = "";
				} else {
					this.isComment = true;
					this.commentDocId = commentDocId;
					this.commentBoxText = commentText;
					this.commentCharacterCount = commentText.length;
				}

				// this.currentTime = 0;
				this.durationTime = this.selectedPodcast.duration;
				if (shouldPlay) {
					this.wavesurfer.play();
				}
			}
		}
	}

	async watchPlayEvent() {
		if (this.isPlaying) {
			let currentTime: any = this.wavesurfer?.getCurrentTime();
			if (currentTime) {
				currentTime = Math.ceil(currentTime);
				if (currentTime > this.selectedPodcast.duration || this.selectedPodcast.duration - currentTime <= 2) {
					currentTime = this.selectedPodcast.duration;
				}
				let progress = Math.ceil((currentTime * 100) / this.selectedPodcast.duration);
				if (progress >= 99 || isNaN(progress)) {
					progress = 100;
					currentTime = this.selectedPodcast.duration;
				}

				let entityId = `${this.selectedPodcast.season_number}_${this.selectedPodcast.episode_number}`;
				let podcastsProgress = this.userData.podcastsProgress;

				let newProgressObj: any = {
					watchedDuration: currentTime,
					totalDuration: this.selectedPodcast.duration,
					entityId,
					progress
				};

				if (progress === 100) {
					newProgressObj.completedAt = new Date();
				}
				if (this.userData && podcastsProgress && podcastsProgress.length >= 1) {
					let hasProgressIndex = podcastsProgress.findIndex((item: any) => item.entityId === entityId);
					if (hasProgressIndex === -1) {
						podcastsProgress.push(newProgressObj);
						await this.dashboardService.updateUserData(this.userId, {
							podcastsProgress
						});
					} else {
						let item = podcastsProgress[hasProgressIndex];

						if (item.progress !== 100) {
							podcastsProgress[hasProgressIndex] = newProgressObj;

							await this.dashboardService.updateUserData(this.userId, {
								podcastsProgress
							});
						}
					}
				} else {
					podcastsProgress = [newProgressObj];
					this.userData.podcastsProgress = podcastsProgress;
					await this.dashboardService.updateUserData(this.userId, {
						podcastsProgress
					});
				}
			}

			this.showCurrentMonthDates();

			setTimeout(async () => {
				await this.watchPlayEvent();
			}, 3000);
		}
	}

	onPlayPause(): void {
		if (!this.isLoadingWavesurfer) {
			if (this.wavesurfer) {
				if (this.isPlaying) {
					this.wavesurfer.pause();
				} else {
					this.wavesurfer.play();
					this.posthog.capture(POSTHOG_EVENT_LATEST_DAILY_DOSE_PODCAST_PLAY, {
						'User email': localStorage.getItem('username'),
						'dose name': this.selectedPodcast?.title,
						'device_type': this.deviceDetectorService.device,
						'role': localStorage.getItem('roleId')
					});
				}
			}
		} else {
			this.snackbar.open("Loading podcast audio...", "OK", {
				duration: 3000
			});
		}
	}

	formatTime(seconds: number): string {
		if (isNaN(seconds)) {
			return "Loading...";
		}
		const minutes = Math.floor(seconds / 60);
		const remainderSeconds = Math.floor(seconds % 60);
		return `${('0' + minutes).slice(-2)}:${('0' + remainderSeconds).slice(-2)}`;
	}

	commentCharacterCount: number = 0;

	onInputChange(event: any) {
		this.commentCharacterCount = event.target.value.length;
	}

	openBottomSheet() {
		if (this.podcasts.length >= 2) {
			const bottomSheetConfig: MatBottomSheetConfig = {
				panelClass: 'mobile-podcast',
				data: {
					isOpen: true,
					podcasts: this.podcasts,
					likesData: this.likesIdData,
					commentsData: this.commentsIdData,
					audioUrls: this.audioUrls,
					userId: this.userId,
					userData: this.userData,
				}
			};
			this._bottomSheet.open(MobilePodcastComponent, bottomSheetConfig);
			this.likesService.setPIPValue('open');
		}
	}

	async saveComment() {
		let entityId = `${this.selectedPodcastSeason}_${this.selectedPodcastEpisode}`;
		await this.likesService.saveComment(this.commentBoxText, entityId, this.userId);
		// this.commentBoxText = "";
		// this.commentCharacterCount = 0;
		this.snackbar.open("Comment saved.", "OK", {
			duration: 3000
		});

		this.posthog.capture(POSTHOG_EVENT_SAVE_COMMENT_DAILY_DOSE, {
			'user email': localStorage.getItem('username'),
			'poadcast name': this.selectedPodcast?.title,
			'device_type': this.deviceDetectorService.device,
			'role': localStorage.getItem('roleId'),
			'date': new Date()
		});
	}

	checkIfAudioIsLoading() {
		if (this.isLoadingWavesurfer) {
			this.snackbar.open("Please wait while the audio loads...", "OK", {
				duration: 2000
			});
			return;
		}
	}

	igxViewDateChanged(event: any) {
		if (event.currentValue) {
			this.showCurrentMonthDates(event.currentValue);
		}
	}

	openAlgorithmBox() {
		if (this.isMonthlyDoseBoxOpen) {
			this.isMonthlyDoseBoxOpen = false;
		}
		this.isCompleteAlgoBoxOpen = !this.isCompleteAlgoBoxOpen;
	}

	openMonthlyDoseBox() {
		if (this.isCompleteAlgoBoxOpen) {
			this.isCompleteAlgoBoxOpen = false;
		}
		this.isMonthlyDoseBoxOpen = !this.isMonthlyDoseBoxOpen;
	}

	async likeQuoteFn(action: string) {
		if (action === 'like') {
			const likeObject = {
				createdAt: new Date(),
				emotionType: "like",
				entityId: this.quoteIndex,
				entityType: "quote",
				userId: this.userId,
				userName: this.username
			}
			await this.likesService.likeQuote(likeObject);
		}
		if (action === 'unlike') {
			await this.likesService.unlikeQuote(this.quoteIndex, this.userId);
		}
	}

	findContinuousDates(dates: any) {
		dates = Array.from(new Set(dates));
		// console.log(dates);
		let streakDates = [];
		let streak = [];

		for (let i = 0; i < dates.length; i++) {
			const currentDate: any = moment(dates[i], "DD-MM-YYYY").toDate();
			const previousDate: any = i > 0 ? moment(dates[i - 1], "DD-MM-YYYY").toDate() : null;
			const nextDate: any = i < dates.length ? moment(dates[i + 1], "DD-MM-YYYY").toDate() : null;

			if (streak.length > 0) {
				if (streak.length >= 5) {
					if (this.isValidStreak(dates, currentDate)) {
						streak.push(dates[i]);
					} else {
						streakDates.push(...streak);
						streak = [];
						if (nextDate && (nextDate - currentDate) === 24 * 60 * 60 * 1000) {
							streak = [dates[i]];
						}
					}
				} else if (previousDate && (currentDate - previousDate) === 24 * 60 * 60 * 1000) {
					streak.push(dates[i]);
				} else {
					streak = [dates[i]];
				}
			} else {
				if (nextDate && (nextDate - currentDate) === 24 * 60 * 60 * 1000) {
					streak = [dates[i]];
				}
			}
		}

		// Check if the last streak meets the criteria
		if (streak.length >= 5) {
			streakDates.push(...streak);
			streak = [];
		}

		// streakDates = Array.from(new Set(streakDates));
		return streakDates.map(dateString => moment(dateString, "DD-MM-YYYY").toDate());
	}

	isValidStreak(dates: any, currentDate: any) {
		let count = 0;
		let weekArray = [moment(currentDate).format("DD-MM-YYYY")];

		for (let i = 1; i <= 6; i += 1) {
			weekArray.push(moment(currentDate).subtract(i, "days").format("DD-MM-YYYY"));
		}

		for (let dateItem of weekArray) {
			if (dates.includes(dateItem)) {
				count += 1;
			}
		}

		if (count >= 6) {
			return true;
		}
		return false;
	}

	getCurrentWeekNumber(): number {
		const currentWeek = moment().week();
		const weekNumber = (currentWeek - 1) % 20 + 1; // This will cycle through 1-20
		return weekNumber;
	}

	getWeeklyImagePath(): string {
		const weekNumber = this.getCurrentWeekNumber();
		const tipPath = `../../../../../assets/images/dashboard_images/Top_Tips_${weekNumber}.png`;
		return tipPath;
	}

	ngOnDestroy() {
		if (this.wavesurfer) {
			this.wavesurfer.destroy();
		}
		this.quotelikeSubscription?.unsubscribe();
	}
}
